import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchGatepassApprovedStatus = createAsyncThunk(
	"fetchGatepassApprovedStatus",
	async (_, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get("status/list?identifier=gatepass&sub=gatepass_approved");
			return response.data;
		} catch (err) {
			if (!err.response) throw err;
			return rejectWithValue(err.response.data);
		}
	}
);

const GatepassApprovedStatusSlice = createSlice({
	name: "GatepassApprovedStatusSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchGatepassApprovedStatus.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchGatepassApprovedStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			// status/list returns an array inside .data
			const statusArray = action.payload?.data || [];
			state.data = statusArray.find((s) => s.sub_identifier === "gatepass_approved") || statusArray[0] || null;
		});
		builder.addCase(fetchGatepassApprovedStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GatepassApprovedStatusSlice.reducer;
